<template>
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>Exhibiting</BreadcrumbItem>
          <BreadcrumbItem>主页设置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <!-- <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibition/template/choice-new?origin=2&type=add')">
          <span class="htb-add">+</span>
          <span>新增云展台</span>
        </div>
      </div> -->
    </div>
    <exhibitionInfoList ref="exhibitionInfoList" />
    <!-- <div v-else class="empty">
      <p>您还未绑定任何展会</p>
      <a href="javascript:;" @click="$router.push('/exhibition/contact-exhibition')">新增云展台</a>
    </div>-->
    <Contact />
  </div>
</template>

<script>
import exhibitionInfoList from "./subpages/exhibition-info-list/exhibition-info-list";
// import exhibitionInfoHistory from "./subpages/exhibition-info-history/exhibition-info-history";
import Contact from "@components/Contact/Contact";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "exhibition-info-wrapper",
  data() {
    return {
      showTabs: "1",
      num: 0,
      list: []
    };
  },
  components: {
    exhibitionInfoList,
    // exhibitionInfoHistory,
    Contact
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    }
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 主页设置";
    // this.$router.push('/exhibition/template/service?origin=2&editId=70822bdf-782a-418a-9c74-d9a76ef43182');
  },
  methods: {
    ...mapActions({
      getByCompany: "exhibitionModule/getByCompany"
    })
  }
};
</script>

<style scoped lang="scss">
.eb-top-r {
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 15px;
  &-box {
    width: 148px;
    height: 78px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.5s;
    &:hover {
      border: 1px dashed #1890ff;
      transition: 0.5s;
    }
    .I1 {
      font-size: 16px;
      font-weight: bold;
      color: #1890ff;
    }
    .s3 {
      font-size: 14px;
      color: #1890ff;
      margin-left: 9px;
    }
  }
}
.empty {
  height: 764px;
  background-color: #fff;
  margin: 30px;
  padding-top: 293px;
  text-align: center;
  box-shadow: 0px 0px 7px 0px rgba(146, 160, 185, 0.2);
  p {
    font-size: 24px;
    color: #333;
    font-weight: bold;
    padding-bottom: 20px;
  }
  a {
    font-size: 24px;
    color: #1890ff;
    font-weight: 400;
  }
}
</style>
